import { validateEmail } from 'utils/helper';

const forgotUsernameSchema = {
  email: [
    {
      rule: 'required',
      error: 'Email is required',
    },
    {
      isValid: (input) => (
        !input || validateEmail(input)
          ? true
          : 'Please enter a valid email address'
      ),
    },
  ],
  ssnLast4: [
    {
      rule: 'required',
      error: 'Last 4 digits of SSN are required',
    },
    {
      isValid: (input) => (
        !input || /^\d{4}$/.test(input)
          ? true
          : 'Please enter the last 4 digits of your SSN'
      ),
    },
  ],
};

export default forgotUsernameSchema;
